import React from 'react';
import Banner from 'components/Banner';
import { useClientStore } from 'apps/hooks';
import { observer } from 'mobx-react';
import { ChangeRoleAction } from 'libs/connection/actions';

export const ChangePortalBanner = observer(() => {
  const clientStore = useClientStore();
  const hasIntermediatorRole = clientStore.hasRole('INTERMEDIATOR');

  const isIntermediatorPortal = clientStore.currentPortal === 'INTERMEDIATOR';
  if (hasIntermediatorRole) {
    if (isIntermediatorPortal) {
      return (
        <>
          <Banner>
            You&apos;re viewing as an Intermediator. You can see all RFQs and
            Orders.
          </Banner>
          <ChangeRoleAction />
        </>
      );
    }
    return (
      <>
        <Banner>You&apos;re viewing this as a normal user.</Banner>
        <ChangeRoleAction />
      </>
    );
  }
  return null;
});
